import Icon from '../Icon.jsx';
import { Check, PageLabel } from '../parts.jsx';

const passportParts = [['user-round', 'Profile & Identity'], ['file-text', 'Documents'], ['house', 'Housing Record']];
const askers = [['house', 'Your landlord', 'Your housing record, when you move'], ['wrench', 'A tradesperson', 'Your address, for one visit']];

export default function PassportPage() {
  return <>
    <section className="mk-container mk-hero is-split-title" aria-labelledby="passport-title">
      <div className="mk-hero-title is-560">
        <PageLabel icon="id-card">Passport</PageLabel>
        <h1 className="mk-display" id="passport-title">Your documents, ready when you need them.</h1>
      </div>
      <div className="mk-hero-aside">
        <p className="mk-lead">Your Passport will keep your ID, documents and housing information in one place. You choose what you share, and who sees it.</p>
        <Check>Nothing is shared until you say yes</Check>
      </div>
    </section>

    <section className="mk-band is-white" id="how-sharing-will-work" aria-labelledby="sharing-title">
      <div className="mk-container mk-stack">
        <h2 className="mk-h2" id="sharing-title">How Sharing Will Work</h2>
        <div className="mk-sharing">
          <div className="mk-sharing-card is-parts">
            <p className="mk-sharing-title">In your Passport</p>
            <ul className="mk-sharing-parts">{passportParts.map(([icon, name]) => <li key={name}><Icon name={icon} size={20}/>{name}</li>)}</ul>
          </div>
          <div className="mk-sharing-link">
            <p className="mk-sharing-link-title">Permissions &amp; Consent</p>
            <span className="mk-sharing-arrow" aria-hidden="true"><span className="mk-sharing-line"/><Icon name="chevron-right" size={22}/></span>
            <p className="mk-sharing-link-label">shared only when you say yes</p>
          </div>
          <div className="mk-sharing-card is-askers">
            <p className="mk-sharing-title">Who might ask</p>
            <ul className="mk-sharing-askers">{askers.map(([icon, who, what]) => <li key={who}>
              <span className="mk-icon-tile is-40"><Icon name={icon} size={20}/></span>
              <span className="mk-sharing-asker-text"><span className="mk-sharing-asker">{who}</span><span className="mk-sharing-what">{what}</span></span>
            </li>)}</ul>
          </div>
        </div>
      </div>
    </section>
  </>;
}
